(function () {

  function waitForVcgData(attempts) {
    if (attempts <= 0) return;
    var vcgData = window.__vcgData;
    if (!vcgData || !vcgData.variants) {
      setTimeout(function() { waitForVcgData(attempts - 1); }, 100);
      return;
    }
    init(vcgData);
  }

  waitForVcgData(20);

  function init(vcgData) {
    var variants = vcgData.variants;
    var colorOptionIndex = vcgData.colorOptionIndex;
    var slideColorMap = vcgData.slideColorMap || {};

    var prefixColorMap = {};
    variants.forEach(function(v) {
      var color = v.options[colorOptionIndex];
      if (!color) return;
      if (v.featured_media && v.featured_media.preview_image) {
        var src = v.featured_media.preview_image.src;
        var prefix = src.split('/').pop().split('?')[0].split('_')[0];
        if (prefix) prefixColorMap[prefix] = color;
      }
    });

    function buildFullPrefixMap() {
      var slides = document.querySelectorAll('media-gallery slideshow-slide');
      var featuredColor = null;
      var firstSlide = slides[0];
      if (firstSlide) {
        var firstTimeline = firstSlide.style.getPropertyValue('--slideshow-timeline') || '';
        var firstMatch = firstTimeline.match(/--slide-(\d+)/);
        if (firstMatch) {
          featuredColor = slideColorMap[parseInt(firstMatch[1], 10)] || null;
        }
      }
      slides.forEach(function(slide) {
        var img = slide.querySelector('img');
        if (!img) return;
        var src = img.src || img.getAttribute('src') || '';
        if (!src) return;
        var prefix = src.split('/').pop().split('?')[0].split('_')[0];
        if (!prefix) return;
        var timeline = slide.style.getPropertyValue('--slideshow-timeline') || '';
        var match = timeline.match(/--slide-(\d+)/);
        if (!match) return;
        var idx = parseInt(match[1], 10);
        var color = slideColorMap[idx];
        if (color != null) {
          prefixColorMap[prefix] = color;
        } else if (featuredColor && !prefixColorMap[prefix]) {
          prefixColorMap[prefix] = featuredColor;
        }
      });
    }

    function getColorFromSlide(slide) {
      if (!slide) return null;
      var img = slide.querySelector('img');
      if (!img) return null;
      var src = img.src || img.getAttribute('src') || '';
      var prefix = src.split('/').pop().split('?')[0].split('_')[0];
      if (prefix && prefixColorMap[prefix]) return prefixColorMap[prefix];
      var keys = Object.keys(prefixColorMap);
      for (var i = 0; i < keys.length; i++) {
        if (src.indexOf(keys[i]) !== -1) return prefixColorMap[keys[i]];
      }
      return null;
    }

    function getColorRadios() {
      var all = document.querySelectorAll('input[type="radio"]');
      var colorValues = variants.map(function(v) { return v.options[colorOptionIndex]; });
      var groups = {};
      all.forEach(function(r) {
        if (!groups[r.name]) groups[r.name] = [];
        groups[r.name].push(r);
      });
      var bestName = null;
      var bestCount = 0;
      Object.keys(groups).forEach(function(name) {
        var matches = groups[name].filter(function(r) { return colorValues.indexOf(r.value) !== -1; }).length;
        if (matches > bestCount) { bestCount = matches; bestName = name; }
      });
      return bestName ? groups[bestName] : [];
    }

    function getColorRadio(color) {
      return getColorRadios().find(function(r) { return r.value === color; }) || null;
    }

    function getSelectedSwatchColor() {
      var checked = getColorRadios().find(function(r) { return r.checked; });
      return checked ? checked.value : null;
    }

    var locked = false;
    var lockTimer = null;

    function getSelectedOptions() {
      var options = [];
      var variantPicker = document.querySelector('variant-picker');
      if (!variantPicker) return options;
      variantPicker.querySelectorAll('fieldset').forEach(function(fs) {
        var checked = fs.querySelector('input[type="radio"]:checked');
        if (checked) options.push(checked.value);
      });
      return options;
    }

    function findMatchingVariant(selectedOptions) {
      return variants.find(function(v) {
        return v.options.every(function(opt, i) {
          return opt === selectedOptions[i];
        });
      }) || null;
    }

    function selectSwatchColor(color) {
      var radio = getColorRadio(color);
      if (!radio || radio.checked) return;

      var variantPicker = document.querySelector('variant-picker');
      locked = true;
      clearTimeout(lockTimer);
      radio.checked = true;

      if (variantPicker && typeof variantPicker.updateSelectedOption === 'function') {
        variantPicker.updateSelectedOption(radio);
      }

      var selectedOptions = getSelectedOptions();
      var matchingVariant = findMatchingVariant(selectedOptions);
      if (matchingVariant) {
        var formInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
        if (formInput) formInput.value = matchingVariant.id;
        history.replaceState({}, '', window.location.pathname + '?variant=' + matchingVariant.id);
      }

      lockTimer = setTimeout(function() {
        locked = false;
        attachListeners();
      }, 600);
    }

    function onSlideVisible(slide) {
      if (locked) return;
      var color = getColorFromSlide(slide);
      if (!color) return;
      if (color !== getSelectedSwatchColor()) {
        selectSwatchColor(color);
      }
    }

    var slideObserver = null;

    function observeSlides() {
      if (slideObserver) slideObserver.disconnect();

      var gallery = document.querySelector('media-gallery');
      if (!gallery) return;

      var observerRoot = gallery.querySelector('slideshow-slides') || gallery;

      slideObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.intersectionRatio >= 0.6) {
            onSlideVisible(entry.target);
          }
        });
      }, {
        root: observerRoot,
        threshold: 0.6
      });

      document.querySelectorAll('media-gallery slideshow-slide:not([hidden])').forEach(function(slide) {
        slideObserver.observe(slide);
      });
    }

    function onGalleryInteraction() {
      var colorAtPress = getColorFromSlide(getCenteredSlide());
      setTimeout(function() { pollForChange(colorAtPress, 25); }, 100);
    }

    function getCenteredSlide() {
      var slides = document.querySelectorAll('media-gallery slideshow-slide:not([hidden])');
      if (!slides.length) return null;
      var gallery = document.querySelector('media-gallery');
      if (!gallery) return null;
      var galleryRect = gallery.getBoundingClientRect();
      var galleryCenter = galleryRect.left + galleryRect.width / 2;
      var closest = null;
      var closestDist = Infinity;
      slides.forEach(function(slide) {
        var rect = slide.getBoundingClientRect();
        var dist = Math.abs((rect.left + rect.width / 2) - galleryCenter);
        if (dist < closestDist) { closestDist = dist; closest = slide; }
      });
      return closest;
    }

    function pollForChange(previousColor, attempts) {
      if (attempts <= 0) return;
      if (locked) {
        setTimeout(function() { pollForChange(previousColor, attempts - 1); }, 80);
        return;
      }
      var slideColor = getColorFromSlide(getCenteredSlide());
      if (!slideColor || slideColor === previousColor) {
        setTimeout(function() { pollForChange(previousColor, attempts - 1); }, 80);
        return;
      }
      if (slideColor !== getSelectedSwatchColor()) {
        selectSwatchColor(slideColor);
      }
    }

    var listenedElements = [];

    function attachSwatchClickListeners() {
      var variantPicker = document.querySelector('variant-picker');
      if (!variantPicker) return;
      var colorFieldset = Array.from(variantPicker.querySelectorAll('fieldset')).find(function(fs) {
        return fs.querySelector('input[type="radio"]') &&
               getColorRadios().some(function(r) { return fs.contains(r); });
      });
      if (!colorFieldset) return;
      colorFieldset.querySelectorAll('label').forEach(function(label) {
        if (listenedElements.indexOf(label) !== -1) return;
        listenedElements.push(label);
        label.addEventListener('pointerdown', function() {
          locked = true;
          clearTimeout(lockTimer);
          lockTimer = setTimeout(function() {
            locked = false;
            attachListeners();
          }, 800);
        });
      });
    }

    function attachListeners() {
      document.querySelectorAll('media-gallery slideshow-arrows').forEach(function(el) {
        if (listenedElements.indexOf(el) !== -1) return;
        listenedElements.push(el);
        el.addEventListener('pointerdown', onGalleryInteraction, true);
      });
      document.querySelectorAll('media-gallery slideshow-controls').forEach(function(el) {
        if (listenedElements.indexOf(el) !== -1) return;
        listenedElements.push(el);
        el.addEventListener('pointerdown', onGalleryInteraction, true);
      });
      attachSwatchClickListeners();
      listenedElements = listenedElements.filter(function(el) { return document.contains(el); });
    }

    var mutationObserver = new MutationObserver(function() {
      attachListeners();
      observeSlides();
    });

    buildFullPrefixMap();
    attachListeners();
    observeSlides();
    mutationObserver.observe(document.body, { childList: true, subtree: true });
  }

})();
